
import { Link, useLocation } from "react-router-dom";
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarSeparator
} from "@/components/ui/sidebar";
import { 
  Home, 
  FileText, 
  Calendar, 
  CalendarCheck, 
  MessageSquare, 
  ThumbsUp, 
  Users as UsersIcon,
  Ribbon
} from "lucide-react";

interface StaffSidebarItemsProps {
  isAdmin: boolean;
}

export const StaffSidebarItems = ({ isAdmin }: StaffSidebarItemsProps) => {
  const location = useLocation();
  console.log("StaffSidebarItems - Current path:", location.pathname);
  
  // Use improved path checking for active state
  const isActive = (path: string) => {
    // Exact match
    if (location.pathname === path) {
      return true;
    }
    
    // Home path is special
    if (path === "/home") {
      return location.pathname === "/home";
    }
    
    // For other paths, check if it's a parent path
    return location.pathname.startsWith(path + "/");
  };
  
  return (
    <>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/home")}>
            <Link to="/home">
              <Home className="h-4 w-4" />
              <span>Home</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>

        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/dashboard")}>
            <Link to="/dashboard">
              <FileText className="h-4 w-4" />
              <span>Policies & Protocols</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>

        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/leave")}>
            <Link to="/leave">
              <Calendar className="h-4 w-4" />
              <span>Leave Requests</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>

      <SidebarSeparator className="my-2" />
      
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/cancer-diagnoses")}>
            <Link to="/cancer-diagnoses">
              <Ribbon className="h-4 w-4" />
              <span>New Cancer Diagnoses</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>

        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/events")}>
            <Link to="/events">
              <CalendarCheck className="h-4 w-4" />
              <span>Significant Events</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>

        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/complaints")}>
            <Link to="/complaints">
              <MessageSquare className="h-4 w-4" />
              <span>Complaints</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>

        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/compliments")}>
            <Link to="/compliments">
              <ThumbsUp className="h-4 w-4" />
              <span>Compliments</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
        
        <SidebarMenuItem>
          <SidebarMenuButton asChild isActive={isActive("/meetings")}>
            <Link to="/meetings">
              <UsersIcon className="h-4 w-4" />
              <span>Practice Meetings</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </>
  );
};
